import type { Card } from '../../types';

/** Legendary three-die finisher. */
export const WORLDBREAKER: Card = {
  id: 'worldbreaker',
  name: 'Worldbreaker',
  type: 'attack',
  rarity: 'legendary',
  size: { w: 3, h: 2 },
  cost: [
    { kind: 'min', value: 5 },
    { kind: 'min', value: 5 },
    { kind: 'min', value: 5 },
  ],
  effects: [{ kind: 'damage', amount: 20 }],
};
